import { PERMISSION } from '@/constants/permission.constant';

const modelList = () => import('@/views/configuration/models/List.vue');
const addModel = () => import('@/views/configuration/models/Add.vue');
const editModel = () => import('@/views/configuration/models/Edit.vue');

export const modelRoute = [
  {
    path: '/configuration/models',
    name: 'model-list',
    component: modelList,
    meta: { requiresAuth: false, permissions: [PERMISSION.MODEL_READ] },
  },

  {
    path: '/configuration/models/create',
    name: 'model-create',
    component: addModel,
    meta: { requiresAuth: false, permissions: [PERMISSION.MODEL_CREATE] },
  },

  {
    path: '/configuration/models/edit',
    name: 'model-edit',
    component: editModel,
    meta: { requiresAuth: false, permissions: [PERMISSION.MODEL_UPDATE] },
  },
];
